import { createRoute, Navigate } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import LoginPage from 'pages/shared/Login/LoginPage';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

export const loginParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  validateSearch: z.object({
    redirection_url: z.string().optional(),
    error_code: z.string().optional(),
  }),
  component: LoginPage,
  pendingComponent: LoadingScreen,
});

export const loginIndexRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/',
  component: () => <Navigate to="/login/phone_number" />,
});
